//initial redux
import { put, call, takeEvery, fork, all, take, takeLatest, select } from "redux-saga/effects";
import { delay } from "redux-saga";
import { TreeFlatener, TreeMap, cloneAsync, AsyncSaga, number, DateTime, persist } from "../../utils";
import config from "../../boot/config";
import { types as logintypes } from "../../ui/Login/redux";
import pointservice from "../../services/points";
import sitesservice from "../../services/sites";
import moment from "moment";
import timezone from "../../utils/timezone";

const initialState = {
	flattenedSiteTree: new TreeMap(),
	flattenedMenuTree: new TreeMap(),
	siteTariffDetails: [],
	menuTree: [],
	currentSite: null,
	currentSiteName: null,
	isBusy: true,
	errors: []
};

const persistConf = {
	whitelist: ["currentSite", "currentSiteName"]
};

/////////
//types
export const types = {
	//flattened site tree contains a flat version of all sites and their children (and those childrens children etc )
	SET_FLATTENED_SITE_TREE: "services/SiteTree/SET_FLATTENED_SITE_TREE",
	SET_FLATTENED_SITE_TREE_FAILED: "services/SiteTree/SET_FLATTENED_SITE_TREE_FAILED.",

	SET_FLATTENED_MENU_TREE: "services/SiteTree/SET_FLATTENED_MENU_TREE",
	SET_FLATTENED_MENU_TREE_FAILED: "services/SiteTree/SET_FLATTENED_MENU_TREE_FAILED",

	SET_SITE_TARIFF_DETAILS: "services/SiteTree/SET_SITE_TARIFF_DETAILS",
	SET_SITE_TARIFF_DETAILS_FAILED: "services/SiteTree/SET_SITE_TARIFF_DETAILS_FAILED",

	SET_MENU_TREE: "services/SiteTree/SET_MENU_TREE",
	SET_CURRENT_SITE: "services/SiteTree/SET_CURRENT_SITE",
	SET_CURRENT_SITE_BY_NAME: "services/SiteTree/SET_CURRENT_SITE_BY_NAME",

	ON_LOAD: "services/SiteTree/ON_LOAD"
};

///////////
//reducers
const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.SET_FLATTENED_SITE_TREE:
				return { ...state, flattenedSiteTree: action.payload.flattenedSiteTree };
			case types.SET_FLATTENED_SITE_TREE_FAILED:
				return { ...state, errors: state.errors.concat(action.payload).slice(-10) };
			case types.SET_FLATTENED_MENU_TREE:
				return { ...state, flattenedMenuTree: action.payload.flattenedMenuTree };
			case types.SET_FLATTENED_MENU_TREE_FAILED:
				return { ...state, errors: state.errors.concat(action.payload).slice(-10) };
			case types.SET_SITE_TARIFF_DETAILS:
				return { ...state, siteTariffDetails: action.payload.siteTariffDetails };
			case types.SET_SITE_TARIFF_DETAILS_FAILED:
				return { ...state, errors: state.errors.concat(action.payload).slice(-10) };
			case types.SET_MENU_TREE: {
				return { ...state, menuTree: action.payload.menuTree };
			}
			case types.SET_CURRENT_SITE: {
				return { ...state, currentSite: action.payload.currentSite };
			}
			case types.SET_CURRENT_SITE_BY_NAME: {
				return { ...state, currentSiteName: action.payload.currentSiteName };
			}
			case types.ON_LOAD:
			default:
				return state;
		}
	}
};
export const reducer = persist("sitetree", reducers.reducer, persistConf);

function* getSiteTree() {
	let flattenedSiteTree = null;

	let stupidFix = config.selectRootViewSitesName.replace(/(\r\n|\n|\r)/gm, "");

	let root = yield call(pointservice.TrendableObjectGetByName, stupidFix);
	if (root instanceof Error) {
		console.error(root);
		yield put(actions.genericAction(types.SET_FLATTENED_SITE_TREE, root));
	} else {
		let children = yield call(pointservice.TrendableObjectGetChildrenFor, root[0].objectID, true);
		if (children instanceof Error) {
			console.error(children);
			yield put(actions.genericAction(types.SET_FLATTENED_SITE_TREE_FAILED, children));
		} else {
			flattenedSiteTree = TreeFlatener.Flatten(children.filter(x => x.parentID === root[0].objectID));

			children = children.filter(x => x.parentID !== root[0].objectID);

			let level = 0;
			while (children.length > 0) {
				let parents = flattenedSiteTree.Where(x => x._tree.level === level);
				if (parents.length === 0) {
					break;
				}

				for (let index = 0; index < parents.length; index++) {
					const parent = parents[index];
					//add the current items' children to flat list
					TreeFlatener.Flatten(
						children.filter(x => x.parentID === parent.objectID),
						null,
						null,
						parent,
						flattenedSiteTree
					);
					//then remove them
					children = children.filter(x => x.parentID !== parent.objectID);
				}
				level++;
			}

			// yield put(actions.setFlattenedSiteTree(flattenedSiteTree));
		}
	}
	return flattenedSiteTree;
}

function* getMenuTree() {
	let flattenedMenuMap = null;
	
	let stupidFix = config.selectRootViewName.replace(/(\r\n|\n|\r)/gm, "");

	const data = yield call(pointservice.TrendableObjectGetByName, stupidFix);
	if (data instanceof Error) {
		console.error(data);
		yield put(actions.genericAction(types.SET_FLATTENED_MENU_TREE_FAILED, data));
	} else {
		if (data.length > 0) {
			let children = yield call(pointservice.TrendableObjectGetChildrenFor, data[0].objectID, true);
			if (children instanceof Error) {
				console.error(children);
				yield put(actions.genericAction(types.SET_FLATTENED_MENU_TREE_FAILED, children));
			} else {
				flattenedMenuMap = TreeFlatener.Flatten(children.filter(x => x.parentID === data[0].objectID));

				children = children.filter(x => x.parentID !== data[0].objectID);

				let level = 0;
				while (children.length > 0) {
					let parents = flattenedMenuMap.Where(x => x._tree.level === level);
					if (parents.length === 0) {
						break;
					}

					for (let index = 0; index < parents.length; index++) {
						const parent = parents[index];
						//add the current items' children to flat list
						TreeFlatener.Flatten(
							children.filter(x => x.parentID === parent.objectID),
							null,
							null,
							parent,
							flattenedMenuMap
						);
						//then remove them
						children = children.filter(x => x.parentID !== parent.objectID);
					}
					level++;
				}
			}
		}
	}
	return flattenedMenuMap;
}

function* getSiteTariffDetails() {
	const siteTariffDetails = yield call(pointservice.NABERSGetSites);
	if (siteTariffDetails instanceof Error) {
		yield put(actions.genericAction(types.SET_SITE_TARIFF_DETAILS_FAILED, siteTariffDetails));
	}
	let states = [];
	if (siteTariffDetails && siteTariffDetails.length) {
		siteTariffDetails.forEach(s => {
			if (states.indexOf(s.state) === -1) {
				states.push(s.state);
			}
		});
		const tariffs = yield all(states.map(state => call(pointservice.TariffGetByName, state)));
		//This search value is needed as the tarrifs returned have garbage data that is filtered out by 
		//searching for .analytics
		const searchValue = ".analytics";
		siteTariffDetails.forEach(s => {
			let searchMatch = s.state.toLowerCase() + searchValue;
			let matching = null;
			for (var ii = 0; ii < tariffs.length; ii++) {
				for (var xx = 0; xx < tariffs[ii].length; xx++) {
					let wkTariff = tariffs[ii][xx];
					if (wkTariff && wkTariff.name.toLowerCase().indexOf(searchMatch) !== -1) {
						matching = wkTariff;
						break;
					}
				}
				if (matching) {
					break;
				}
			}
			if (matching) {
				s.tariffId = matching.tariffID;
			}
		});
	}

	//const pointDetails = yield all(pointIds.map(pointId => call(pointsservice.TrendableObjectGetObject, pointId)));
	return siteTariffDetails;
}

function getMenuNode(menuTreeNode, flattenedSiteTree) {
	let newNode = {
		name: menuTreeNode.name,
		isSite: menuTreeNode.name.indexOf("Site_") === 0,
		children: []
	};
	if (newNode.isSite) {
		newNode.site = flattenedSiteTree.First(x => x.name == newNode.name);
	}
	for (var ii = 0; ii < menuTreeNode.children.length; ii++) {
		let childNode = getMenuNode(menuTreeNode.children[ii], flattenedSiteTree);
		if (childNode) {
			newNode.children.push(childNode);
		}
	}
	if (newNode.isSite || newNode.children.length) {
		return newNode;
	} else {
		return null;
	}
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.loadEverything(), this.onSetCurrentSiteByName()]);
	},
	*loadEverything() {
		yield takeEvery(logintypes.ON_LOGIN, function*({ payload }) {
			const [flattenedSiteTree, flattenedMenuTree, siteTariffDetails] = yield all([
				call(getSiteTree),
				call(getMenuTree),
				call(getSiteTariffDetails)
			]);
			flattenedSiteTree.Roots.forEach(root => {
				let matchingSite = siteTariffDetails.find(
					s => root.name === "Site_" + s.siteName || root.name === s.siteName
				);
				if (matchingSite) {
					root.state = matchingSite.state;
					root.tariffId = matchingSite.tariffId;
					root.timezone = matchingSite.timezone;
					root.momentTimezone = timezone.getFromCSharpTimezone(root.timezone);
				} else {
					root.state = null;
				}
			});
			let menuTree = TreeFlatener.ToTree(flattenedMenuTree, () => "children");
			if (!Array.isArray(menuTree)) {
				menuTree = [menuTree];
			}

			let newMenuTree = [];
			for (var ii = 0; ii < menuTree.length; ii++) {
				let newNode = {
					name: menuTree[ii].name,
					isRoot: true,
					children: []
				};
				if (menuTree[ii].children.length) {
					for (var jj = 0; jj < menuTree[ii].children.length; jj++) {
						let childNode = getMenuNode(menuTree[ii].children[jj], flattenedSiteTree);
						if (childNode) {
							newNode.children.push(childNode);
						}
					}
				}
				if (newNode.children.length) {
					newMenuTree.push(newNode);
				}
			}

			const state = yield select(x => x.sitetree);
			const persistState = yield select(x => x.persist);
			let currentSite = null;

			if (newMenuTree.length > 0) {
				//try find by name
				if (state.currentSiteName && !state.currentSite) {
					currentSite = flattenedSiteTree.First(x => x.name === state.currentSiteName);
				} else if (persistState && persistState.currentSiteName) {
					currentSite = flattenedSiteTree.First(x => x.name === persistState.currentSiteName);
				}

				//else get first site
				if (currentSite === null && !state.currentSite) {
					//init to first site
					let wkNode = newMenuTree[0];
					while (currentSite === null) {
						if (wkNode.isSite) {
							currentSite = wkNode.site;
							wkNode.selected = true;
						} else {
							wkNode = wkNode.children[0];
						}
					}
				}

				yield put(actions.setMenuTree(newMenuTree));
				yield put(actions.setFlattenedSiteTree(flattenedSiteTree));
				yield put(actions.setFlattenedMenuTree(flattenedMenuTree));
				yield put(actions.setSiteDetails(siteTariffDetails));
				if (!state.currentSite) yield put(actions.setCurrentSite(currentSite));
				yield put(actions.onLoad(state.currentSite || currentSite));
			}
		});
	},
	*onSetCurrentSiteByName() {
		yield takeEvery(types.SET_CURRENT_SITE_BY_NAME, function*({ payload }) {
			const flattenedSiteTree = yield select(x => x.sitetree.flattenedSiteTree);

			let result = flattenedSiteTree.First(x => x.name === payload.currentSiteName);

			yield put(actions.setCurrentSite(result));
		});
	}
};

////////
//actions
export const actions = {
	setFlattenedSiteTree(flattenedSiteTree) {
		return {
			type: types.SET_FLATTENED_SITE_TREE,
			payload: { flattenedSiteTree }
		};
	},
	onLoad(currentSite) {
		return {
			type: types.ON_LOAD,
			payload: { currentSite }
		};
	},
	setFlattenedMenuTree(flattenedMenuTree) {
		return {
			type: types.SET_FLATTENED_MENU_TREE,
			payload: { flattenedMenuTree }
		};
	},
	setSiteDetails(siteDetails) {
		return {
			type: types.SET_SITE_TARIFF_DETAILS,
			payload: { siteDetails }
		};
	},
	setMenuTree(menuTree) {
		return {
			type: types.SET_MENU_TREE,
			payload: { menuTree }
		};
	},
	setCurrentSite(currentSite) {
		return {
			type: types.SET_CURRENT_SITE,
			payload: { currentSite }
		};
	},
	setCurrentSiteName(currentSiteName) {
		return {
			type: types.SET_CURRENT_SITE_BY_NAME,
			payload: { currentSiteName }
		};
	},
	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/services/SiteTree/redux.js